// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","hiding":"Modal_hiding__6-w2M","hidden":"Modal_hidden__ZB9cc","header":"Modal_header__fOQI0","close":"Modal_close__V34Fj","body":"Modal_body__q5AFJ"};